import {
  CardAccount,
  CardAccountcardTypeEnumType,
  DeliveryMethoddeliveryTypeEnumType,
  EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin,
  FundingSourceoriginEnumType,
  Maybe,
  PartnerAccount,
  PartnerPaymentAccountTypeName
} from '@tools/ui/types/generated/graphql';

export enum PaymentMethodType {
  BANK = 'BANK',
  PLAID = 'PLAID',
  SHOPIFY = 'SHOPIFY',
  CREDIT_CARD = 'CREDIT_CARD',
  DEBIT_CARD = 'DEBIT_CARD',
  QB_CASH = 'QB_CASH',
  UNKNOWN = 'UNKNOWN',
  CHECK = 'CHECK',
  RPPS = 'RPPS',
  VIRTUAL_CARD = 'VIRTUAL_CARD',
  INTERNATIONAL = 'INTERNATIONAL',
  CARD = 'CARD',
  DOMESTIC_WIRE = 'DOMESTIC_WIRE',
  FLEX = 'FLEX'
}

type Type = {
  plaidAccountId?: Maybe<number>;
  bankAccountId?: Maybe<number>;
  cardAccount?: Maybe<CardAccount>;
  intuitAccountId?: Maybe<string>;
  paperCheckId?: Maybe<number>;
  rppsAccountId?: Maybe<number>;
  flexAccountId?: Maybe<number>;
  origin?:
    | FundingSourceoriginEnumType
    | EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin
    | null;
  partnerAccount?: Maybe<PartnerAccount>;
  deliveryType?: Maybe<DeliveryMethoddeliveryTypeEnumType>;
};

export const detectPaymentMethodType = ({
  plaidAccountId,
  bankAccountId,
  cardAccount,
  intuitAccountId,
  paperCheckId,
  rppsAccountId,
  flexAccountId,
  origin,
  partnerAccount,
  deliveryType
}: Type = {}): PaymentMethodType => {
  if (rppsAccountId) {
    return PaymentMethodType.RPPS;
  }
  if (intuitAccountId && origin === FundingSourceoriginEnumType.qbcash) {
    return PaymentMethodType.QB_CASH;
  }
  if (
    partnerAccount?.typeName === PartnerPaymentAccountTypeName.ShopifyBalance
  ) {
    return PaymentMethodType.SHOPIFY;
  }
  if (plaidAccountId) {
    return PaymentMethodType.PLAID;
  }
  if (flexAccountId) {
    return PaymentMethodType.FLEX;
  }
  if (bankAccountId) {
    return PaymentMethodType.BANK;
  }
  if (cardAccount?.cardType === CardAccountcardTypeEnumType.credit) {
    return PaymentMethodType.CREDIT_CARD;
  }
  if (cardAccount?.cardType === CardAccountcardTypeEnumType.debit) {
    return PaymentMethodType.DEBIT_CARD;
  }
  if (paperCheckId) {
    return PaymentMethodType.CHECK;
  }
  switch (deliveryType) {
    case DeliveryMethoddeliveryTypeEnumType.virtualCard:
      return PaymentMethodType.VIRTUAL_CARD;
    case DeliveryMethoddeliveryTypeEnumType.international:
      return PaymentMethodType.INTERNATIONAL;
    case DeliveryMethoddeliveryTypeEnumType.card:
      return PaymentMethodType.CARD;
    case DeliveryMethoddeliveryTypeEnumType.domesticWire:
      return PaymentMethodType.DOMESTIC_WIRE;
  }
  return PaymentMethodType.UNKNOWN;
};
